import { useContext } from 'react';
import { CiMenuBurger } from 'react-icons/ci';
import { FaClipboardList, FaTruck, FaUserCircle, FaUsers } from "react-icons/fa";
import { RiFileUserFill } from "react-icons/ri";
import { RxExit } from "react-icons/rx";
import { NavLink, useNavigate } from 'react-router-dom';
import { UserContext } from '../utils/UserContext';

const SideBar = ({ isSidebarOpen, toggleSidebar, setIsLogin }) => {
    const { user, selectedWorkshop } = useContext(UserContext);
    const navigate = useNavigate();

    const links = [
        // { name: "Talleres", path: "/talleres", icon: <MdHomeWork />, enabled: true },
        { name: "Ordenes", path: "/ordenes", icon: <FaClipboardList />, enabled: !!selectedWorkshop },
        { name: "Clientes", path: "/clientes", icon: <RiFileUserFill />, enabled: !!selectedWorkshop },
        { name: "Personal", path: "/personal", icon: <FaUsers />, enabled: !!selectedWorkshop },
        { name: "Proveedor", path: "/proveedor", icon: <FaTruck />, enabled: !!selectedWorkshop },
    ];

    const clickLogout = () => {
        navigate('/logout');
    };

    return (
        <div className={`sidebar ${isSidebarOpen ? 'open' : 'closed'}`}>
            <button className="toggle-sidebar-btn" onClick={toggleSidebar}>
                <CiMenuBurger />
            </button>
            <div className="links-container">
                {links.map((item, index) => (
                    <NavLink
                        to={item.enabled ? item.path : '#'}
                        key={index}
                        className={({ isActive }) => `link ${isActive ? 'active' : ''} ${!item.enabled ? 'disabled' : ''}`}
                    >
                        <span className="link-icon">{item.icon}</span>
                        {isSidebarOpen && <span className="link-text">{item.name}</span>}
                    </NavLink>
                ))}
            </div>
            <footer className="user-section">
                <div className="user-info">
                    <FaUserCircle className="user-icon" />
                    {isSidebarOpen && <div className="username">{user?.username}</div>}
                </div>
                <div className="logout" onClick={clickLogout}>
                    <RxExit className="logout-icon" />
                    {isSidebarOpen && <span>Cerrar Sesión</span>}
                </div>
            </footer>
        </div>
    );
};

export default SideBar;